import { CurrentStatus } from '@/features/oneChatSettings/model';

export interface SettingsEvent<Data = void> {
  readonly name: string;
  readonly data: Data;
}

export interface SettingsEventDefinition<Data = void> {
  readonly eventName: string;
  (data: Data): SettingsEvent<Data>;
}

const defineEvent = <Data = void>(
  name: string,
): SettingsEventDefinition<Data> => {
  const create = (data: Data) => ({ name, data });
  create.eventName = name;
  return create;
};

export const enum ChatVisibility {
  Visible = 'visible',
  Minimized = 'minimized',
}

export const enum BubbleState {
  Visible = 'visible',
  Hidden = 'hidden',
}

const visual = defineEvent<ChatVisibility>('visual');
const status = defineEvent<CurrentStatus>('status');

const openMessages = defineEvent('openMessages');
const openVisitorMessages = defineEvent('openVisitorMesages');
const openAssistantMessages = defineEvent('openAssistantMessages');
const openContactForm = defineEvent('openContactForm');
const openCardMessages = defineEvent('openCardMessages');
const bubble = defineEvent<BubbleState>('bubble');

export const settingsEvents = {
  visual,
  status,
  openMessages,
  openVisitorMessages,
  openContactForm,
  openAssistantMessages,
  openCardMessages,
  bubble,
};
